import { watch } from 'vue';
import { useMagicKeys } from '@vueuse/core';
import { useGlobalSearch } from '@/composables/useGlobalSearch';

export function useGlobalSearchShortcut() {
    const { open, openSearch, closeSearch } = useGlobalSearch();
    const { Meta_k, Ctrl_k } = useMagicKeys();

    watch([Meta_k, Ctrl_k], ([meta, ctrl]) => {
        if (meta || ctrl) {
            open.value ? closeSearch() : openSearch();
        }
    });
}
